import { render, staticRenderFns } from "./MobOverviewIndex.vue?vue&type=template&id=0143dca4&scoped=true"
import script from "./MobOverviewIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MobOverviewIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobOverviewIndex.vue?vue&type=style&index=0&id=0143dca4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143dca4",
  null
  
)

export default component.exports